<script>
    import PositiveClaim from '../../../assets/pictures/w3-claim-positive.svg'
    import NegativeClaim from '../../../assets/pictures/w02-claim-negative.svg'
    import NeutralClaim from '../../../assets/pictures/w1-claim-neutral.svg'
    export let type = ''
</script>

<div>
    {#if type == 'positive'}
        <img
            width="154"
            height="auto"
            draggable="false"
            src={PositiveClaim}
            alt=""
        />
    {:else if type == 'negative'}
        <img
            width="154"
            height="auto"
            draggable="false"
            src={NegativeClaim}
            alt=""
        />
    {:else}
        <img
            width="154"
            height="auto"
            draggable="false"
            src={NeutralClaim}
            alt=""
        />
    {/if}
    <slot />
</div>

<style>
    div {
        width: 100%;
        min-width: 500px;
        max-width: 1000px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 500px;
    }
</style>
